import { WorkGridItemObject } from '@it2go/types';
import { WorkTypeEnum } from '@libs/types/src/common/enum/work-type.enum';
import type { StartWorkExportInput } from '@libs/types/src/services/input-type/work/start-work-export.input';
import { WorkExportScopeEnum } from '@libs/types/src/services/enum/work-export.enum';
import { FormControl, FormGroup } from '@angular/forms';
import {
    WorkExportServicePatternOptionsObject,
} from '@libs/types/src/services/object-type/work/work-export-preparation.object';

export const WORK_PRINT_ALL_TYPES: WorkTypeEnum[] = Object.values(WorkTypeEnum);

export const WORK_PRINT_DAILY_RECORD_TYPES: WorkTypeEnum[] = [
    WorkTypeEnum.VISIT,
    WorkTypeEnum.UNREALIZED_VISIT,
    WorkTypeEnum.EXTRAMURAL_CARE,
    WorkTypeEnum.RESIDUARY_CARE,
    WorkTypeEnum.INTERVENTION,
    WorkTypeEnum.DOCTOR_RECORD,
    WorkTypeEnum.SPECIALIST_RECORD,
];

export type WorkPrintDialogMode = 'row' | 'bulk';
export type WorkPrintAction = 'print' | 'medicalReport';

export interface WorkPrintDialogData {
    mode: WorkPrintDialogMode;
    selectedWorks: WorkGridItemObject[];
    supportedWorkTypes: WorkTypeEnum[];
    dateFrom: Date | null;
    dateTo: Date | null;
    archiveDefault: boolean;
    showMedicalReport: boolean;
    scope: WorkExportScopeEnum;
    folderIds: number[];
    serviceIds: number[];
    medicalReportFolderId: number | null;
    medicalReportServiceId: number | null;
}

export interface OpenWorkBulkPrintOptions {
    selection: WorkGridItemObject | WorkGridItemObject[] | null | undefined;
    supportedWorkTypes: WorkTypeEnum[];
    dateFrom: Date | null;
    dateTo: Date | null;
    archiveDefault?: boolean;
    showMedicalReport?: boolean;
    folderIds?: number[];
    serviceIds?: number[];
    scope?: WorkExportScopeEnum;
    medicalReportFolderId?: number | null;
    medicalReportServiceId?: number | null;
}

export interface OpenWorkRowPrintOptions {
    scope?: WorkExportScopeEnum;
    folderIds?: number[];
    serviceIds?: number[];
}

export interface WorkPrintPayload extends StartWorkExportInput {
    action: WorkPrintAction;
}

export type WorkPrintServicePatternForm = FormGroup<{
    serviceId: FormControl<number>;
    headerId: FormControl<number | null>;
    footerId: FormControl<number | null>;
}>;

export interface WorkPrintServicePatternRow {
    service: WorkExportServicePatternOptionsObject;
    form: WorkPrintServicePatternForm;
}
